import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { dateParser } from "services/utils/commonFunctions/CommonFunctions";
import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";

function DateRangePicker() {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [errorMessage] = useState(null);

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const capitalizeStatus = (str) => {
    if (str) {
      return str?.charAt(0).toUpperCase() + str?.slice(1);
    }
  };

  const changeStatusText = (data, kycData) => {
    let statusName;
    if (data == 0) {
      statusName = "In Progress";
    } else if (data == 1) {
      statusName = kycData == "kycStatus" ? "Approved" : "Complete";
    } else if (data == 2) {
      statusName = kycData == "kycStatus" ? "Rejected" : "Failed";
    } else if (data == 3 && kycData == "kycStatus") {
      statusName = "On Hold";
    }
    return statusName;
  };

  const changePenantStatusText = (pennantStatus, fusionApprovalStatus) => {
    let statusName;
    if (pennantStatus == -1) {
      return (statusName = "NA");
    } else if (pennantStatus == -2) {
      return (statusName = "");
    }
    if (pennantStatus == 0) {
      statusName = "In Progress";
    } else if (pennantStatus == 1) {
      statusName = "Complete";
    } else if (pennantStatus == 2) {
      statusName = "Failed";
    } else if (pennantStatus == 3) {
      // statusName = "On Hold";
      statusName = "Rejected";
    }
    return statusName;
  };

  const statusText = (status) => {
    let statusName;
    if (status == -1) {
      return (statusName = "NA");
    } else if (status == -2) {
      return (statusName = "Not Started");
    }
    if (["", "0"].includes(status)) {
      statusName = "In Progress";
    } else if (status == "1") {
      statusName = "Complete";
    } else if (status == "2") {
      statusName = "Failed";
    } else if (status == "3") {
      statusName = "Rejected";
    }
    return statusName;
  };

  const formatter = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const handleExportClick = async () => {
    const data = {
      fromLeadDate: formatter(fromDate),
      toLeadDate: formatter(toDate),
    }
    const res = await callWebService(
      callTypes.post,
      data,
      Config.downloadLeadList 
  );
    // const res = await downloadLeadList({
    //   fromLeadDate: formatter(fromDate),
    //   toLeadDate: formatter(toDate),
    // });
    if (res?.data?.data) {
      const filteredData = res?.data?.data?.map((d, index) => {
        return {
          "S. No.": index + 1,
          "Application Number": d?.partner_application_no,
          "DA Application Number": d?.application_no,
          "Applicant Name": d?.applicant_name,
          "Partner Name": d?.partner_name,
          "Partner Code": d?.partner_code,
          "BRE Status": d?.bre_approval_status,
          "Credit Status": d?.credit_approval_status === "-1" ? "" : d?.credit_approval_status,
          "CRM ID": d?.crm_id,
          "Product Verification Status": capitalizeStatus(
            d?.crm_approval_status
          ),
          "CRM Process Status": changeStatusText(d?.crm_status),
          "Fusion ID": d?.kellton_id,
          "Fusion Status": changeStatusText(d?.fusion_status),
          "KYC Status": changeStatusText(
            d?.fusion_approval_status,
            "kycStatus"
          ),
          "Primary CIF Number": d?.primary_cif,
          "LAN Number": d?.lan_number,
          "Pennant Process Status": changePenantStatusText(
            d?.pennant_status,
            d?.fusion_approval_status
          ),
          Status: statusText(d?.status),
          "Lead Creation Date": d?.created_at
            ? dateParser(d?.created_at, "MM-DD-YYYY")
            : null,
          "Order Date": d?.orderdate
            ? dateParser(d?.orderdate, "MM-DD-YYYY")
            : null,
          Remark: d?.application_remark,
        };
      });
      convertJsonToXlsx(filteredData, "leadData");
    }
  };

  function convertJsonToXlsx(jsonData, filename) {
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, filename + ".xlsx");
  }

  return (
    <div style={{ fontSize: "1.25rem", marginTop: "1.5rem" }}>
      <div>Export Lead Data</div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          gap: "0.25rem",
        }}
      >
        <DatePicker
          selected={fromDate}
          onChange={handleFromDateChange}
          selectsStart
          startDate={fromDate}
          endDate={toDate}
          placeholderText="From Date"
          dateFormat="yyyy-MM-dd"
          maxDate={new Date() && (toDate ? new Date(toDate) : new Date())}
        />
        <DatePicker
          selected={toDate}
          onChange={handleToDateChange}
          selectsEnd
          startDate={fromDate}
          endDate={toDate}
          minDate={fromDate}
          placeholderText="To Date"
          dateFormat="yyyy-MM-dd"
          maxDate={new Date()}
        />
        <button
          disabled={errorMessage || !fromDate || !toDate}
          className="btn btn-primary"
          onClick={handleExportClick}
        >
          Export
        </button>
      </div>
      <span
        style={{
          display: "block",
          marginTop: "0.5rem",
          fontWeight: "normal",
          color: "red",
        }}
      >
        {errorMessage && <span>{errorMessage}</span>}
      </span>
    </div>
  );
}

export default DateRangePicker;
